import { z } from 'zod';

export const marketingGoalSchema = z.object({
  id: z.number().int().positive(),
  code: z.string(),
  label: z.string(),
  sortOrder: z.number().int(),
  isActive: z.boolean(),
});

export type MarketingGoal = z.infer<typeof marketingGoalSchema>;

/**
 * DTO for creating a marketing goal (admin).
 * Code must be unique; will be validated by the server.
 */
export const marketingGoalCreateSchema = z.object({
  code: z.string().min(1).max(64),
  label: z.string().min(1).max(128),
  sortOrder: z.number().int().nonnegative().default(0),
  isActive: z.boolean().default(true),
});

export type MarketingGoalCreate = z.infer<typeof marketingGoalCreateSchema>;

/**
 * DTO for updating a marketing goal (admin).
 * All fields are optional for PATCH requests.
 */
export const marketingGoalUpdateSchema = z.object({
  code: z.string().min(1).max(64).optional(),
  label: z.string().min(1).max(128).optional(),
  sortOrder: z.number().int().nonnegative().optional(),
  isActive: z.boolean().optional(),
});

export type MarketingGoalUpdate = z.infer<typeof marketingGoalUpdateSchema>;
